import { schema } from 'normalizr';

import { processNotification } from '../strategies/notifications';

import { broadcastForNotificationSchema } from './broadcastForNotification';
import { campaignCoverImageSchema } from './campaignCoverImage';
import { campaignReferencesSchema } from './campaignReferences';
import { delegationRequestSchema } from './delegationRequest';
import { groupSchema } from './group';
import { messageSchema } from './message';
import { teamsMeetingSchema } from './teamsMeeting';
import { threadSchema } from './thread';
import { threadScopeSchema } from './threadScope';
import { topicSchema } from './topic';
import { userSchema } from './user';
import { userReactionAccentColorsSchema } from './userReactionAccentColors';
import { viewerIsFollowingUserSchema } from './viewerIsFollowingUser';

const notificationDetailsSchema = new schema.Object({
  groupId: groupSchema,
  featuredReactionUserIds: [userReactionAccentColorsSchema],
  markingUserId: userSchema,
  threadId: threadSchema,
  messageId: messageSchema,
  broadcastId: broadcastForNotificationSchema,
  addingUserId: userSchema,
  postingUserId: userSchema,
  onBehalfOfUserId: userSchema,
  requestingUserId: userSchema,
  featuredFollowerUserIds: [userSchema],
  userId: userSchema,
  featuredVotingUserIds: [userSchema],
  featuredUpvotingUserIds: [userSchema],
  wallOwnerId: userSchema,
  scope: threadScopeSchema,
  viewerIsFollowingUsers: [viewerIsFollowingUserSchema],
  teamsMeetingId: teamsMeetingSchema,
  campaignId: campaignReferencesSchema,
  campaignCoverImageId: campaignCoverImageSchema,
  subscribedTopics: [topicSchema],
  applyingUsers: [userSchema],
  delegateRequestId: [delegationRequestSchema],
  nominatedUserId: userSchema,
});

const notificationSchema = new schema.Entity(
  'notifications',
  { details: notificationDetailsSchema },
  { processStrategy: processNotification }
);

export const notificationPaginationsSchema = new schema.Object({
  edges: [new schema.Object({ node: notificationSchema })],
});
